import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import SideNavigation from "../../Menu-sidenavbar/SideNavigation ";
import HeaderBackground from "../../../common/SubpagesBGimage";
import { AcademictimetableActions } from "../../../Store/Academic-time-table/action";

function AcademicTimetable() {
  const dispatch = useDispatch();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);
  const location = useLocation();

  const routeNames = {
    "/pedagogy/academic-time-table": {
      menuName: "Pedagogy",
      subMenuName: "Academic Timetable",
    },
  };

  const getCurrentAcademicYear = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const startYear =
      currentDate.getMonth() < 6 ? currentYear - 1 : currentYear;
    return `${startYear}-${startYear + 1}`;
  };

  

  useEffect(() => {
    const currentYear = getCurrentAcademicYear();
    dispatch({
      type: AcademictimetableActions.GET_ACADEMIC_TIMETABLE,
      payload: { year: currentYear },
    });
  }, [dispatch]);

  const generatePdfLinks = (timetable) => {
    const pdfLinks = [];
    for (let year = 1; year <= 5; year++) {
      const oddPdf = timetable[`year_${year}_odd_pdf`];
      const evenPdf = timetable[`year_${year}_even_pdf`];

      // Only consider links that end with .pdf (i.e., valid PDF file links)
      const validOddPdf =
        oddPdf && oddPdf.trim().endsWith(".pdf") ? oddPdf : null;
      const validEvenPdf =
        evenPdf && evenPdf.trim().endsWith(".pdf") ? evenPdf : null;

      pdfLinks.push({
        year,
        oddPdf: validOddPdf,
        evenPdf: validEvenPdf,
      });
    }
    return pdfLinks;
  };

  const { menuName, subMenuName } =
    location.state || routeNames[location.pathname] || {};

  const { AcademictimetableData } = useSelector(
    (state) => state?.AcademictimetableReducer
  );

  useEffect(() => {
    
  }, [AcademictimetableData]);

  // Get current year data - this is the key fix
  const currentYear = getCurrentAcademicYear();
  const currentYearData = AcademictimetableData?.academic_timetable?.find(
    (item) => item.year === currentYear
  );

  const yearLabels = [
    "1'st Year",
    "2'nd Year",
    "3'rd Year",
    "4'th Year",
    "Final Year",
  ];

  return (
    <div>
      <HeaderBackground
        menuName={menuName}
        subMenuName={subMenuName}
        handleMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
      />
      <section className="section-padding">
        <div className="container">
          <h1 className="fw-300 academic-tt heading-submenu-res overall-submenu-heading">
            Academic Timetable
          </h1>
          {currentYearData ? (
            <table className="rwd-table timetable-res mt-15">
              <thead className="desktop-only">
                <tr className="desktop-only1">
                  <th className="border-right timetable-year abc">Year</th>
                  {yearLabels.map((label, index) => (
                    <th
                      key={index}
                      className="border-right timetable-years abc"
                    >
                      {label}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                <tr className="academic-timetable-row desktop-only1">
                  <td
                    data-th="Year"
                    className="academic-timetable academic-timetable-row academic-calendar-responsive def"
                  >
                    {currentYearData.year}
                  </td>
                  {generatePdfLinks(currentYearData).map((links, index) => (
                    <td
                      key={index}
                      data-th={yearLabels[index]}
                      className="pdf-links-cell res-cells def"
                    >
                      {links.oddPdf || links.evenPdf ? (
                        <>
                          {links.oddPdf && (
                            <a
                              className="hov-line timetable-sem res-sem"
                              href={links.oddPdf}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              ODD Sem
                            </a>
                          )}
                          {links.oddPdf && links.evenPdf && (
                            <span className="separator">, </span>
                          )}
                          {links.evenPdf && (
                            <a
                              className="hov-line timetable-sem res-sem"
                              href={links.evenPdf}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              EVEN Sem
                            </a>
                          )}
                        </>
                      ) : (
                        <span className="no-data">N/A</span>
                      )}
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          ) : (
            <div className="no-data-message mt-30 text-center text-danger">
              No timetable available for the academic year {currentYear}.
            </div>
          )}
        </div>
      </section>
      <SideNavigation
        key={menuName}
        isMenuOpen={isMenuOpen}
        handleMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
        openKeys={openKeys}
        onOpenChange={setOpenKeys}
        defaultOpenSubMenu={menuName}
      />
    </div>
  );
}

export default AcademicTimetable;
